module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "marketstudies-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "adsOpen": _vm.adsOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Ads_index')))]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.ads_index_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewAd($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_ad_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "section-container",
      staticStyle: {
        "background-color": "#fafafc",
        "padding": "2rem"
      }
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Address_referral')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    })])])])])])], 1), _vm._v(" "), _c('bar')], 1)], 1)]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-050ca1aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/ads/AdsIndex.vue
// module id = 2101
// module chunks = 0